module.exports = __webpack_public_path__ + "static/media/billboard_930pxWide_For1350pxWideScreen.d455a876.png";